// extracted by css-extract-rspack-plugin
export default {"cls1":"common-cls1_HDL","cls2":"common-cls2_bjm common-cls1_HDL"};